import { useContext, useEffect } from "react";
import { useState } from "react";
import { createContext } from "react";
import { authenticateService } from "./services/CommonService";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState("LoggedIn");
  useEffect(() => {
    console.log("AuthProvider useEffect");
    authenticateService().then((res) => {
      if (res.jwt) {
        setUser("LoggedIn");
      } else {
        setUser(null);
        logout();
      }
    });
  });

  const login = (user) => {
    setUser(user);
  };

  const logout = () => {
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
